import { type SxProps, type Theme } from '@mui/system';

export const dialogSx: SxProps<Theme> = {
  '& .bi-x': {
    position: 'absolute',
    top: '42px',
    right: '40px',
    cursor: 'pointer',
  },
  '& .MuiPaper-root': {
    margin: {
      xs: '6px',
      md: '32px',
    },
    minWidth: {
      xs: '360px',
      lg: '940px',
    },
  },
  '& .MuiDialogContent-root': {
    padding: '12px 40px 12px 30px',
  },
  '& .MuiDialogTitle-root': {
    color: '#006EC2',
    fontSize: '28px',
    fontWeight: 'bold',
    borderBottom: 'solid 2px #ECECEC',
    margin: '0px 30px 30px',
    padding: '34px 0px 15px',
  },
  '& .MuiDialogActions-root': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '50px',
    gap: '30px',
    '& .MuiButton-root': {
      width: '132px',
      textTransform: 'none',
      fontSize: '18px',
      background: '#006EC2',
      color: '#FFFFFF',
      '&.Mui-disabled': {
        background: '#707070',
      },
    },
  },
  '& label': {
    color: '#006EC2',
    fontSize: '18px',
    fontWeight: 'bold',
    marginRight: {
      xs: '12px',
      md: '24px',
    },
    marginTop: 0,
    minWidth: '125px',
    height: '40px',
    lineHeight: '40px',
    textAlign: 'right',
    ':after': {
      content: '":"',
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '7px 16px',
    color: '#000000',
    fontSize: '18px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#006EC2',
  },
};
